import Question from '@/dex-shared/models/QuestionModel';

class SubjectModel extends Question {
  year: number;
  boardSectionId: number;

  constructor(question: any, getters: any) {
    super(question, getters);
    if (question.createdAt) {
      this.year = question.createdAt.slice(0, 4);
    } else {
      this.year = null;
    }
  }
  link() {
    return `/tema/${this.slug}/1`;
  }
  boardSection() {
    let materials = this.materials();
    if (materials.length > 0) {
      return materials[0].boardSection();
    } else {
      return { id: null, title: 'Outros' };
    }
  }
}

export default SubjectModel;
